const prod = {
  port: 443,
  server_url: "https://globalize.360-advisor.com",
  api_prefix: "/api",
  languages: [
    { value: "da", name: "Dansk" },
    { value: "en", name: "Engelsk" },
    { value: "pl", name: "Polsk" }
  ]
};

const dev = {
  port: 443,
  server_url: "https://globalize.360-advisor.com",
  api_prefix: "/api",
  languages: [
    { value: "da", name: "Dansk" },
    { value: "en", name: "Engelsk" },
    { value: "pl", name: "Polsk" }
  ]
};

export let Config = process.env.NODE_ENV === "development" ? dev : prod;
